import { render, staticRenderFns } from "./PageFieldGroupsRestore.vue?vue&type=template&id=debfc29c&scoped=true&"
import script from "./PageFieldGroupsRestore.vue?vue&type=script&lang=js&"
export * from "./PageFieldGroupsRestore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "debfc29c",
  null
  
)

export default component.exports